import React, { useEffect, useState } from 'react';
import Subscription from '../components/settings/Subscription';
import api from '../services/Api';
import Title from '../components/Title';
import ImageUploadPage from '../components/settings/ImageUpload';
import AdPlacementForm from '../components/settings/AdPlacementForm';
import TestimonialReviewPage from '../components/settings/Testimonial';
import BusinessTypeSettings from '../components/settings/BusinessTypeSettings';

const Settings = () => {
  const [activeTab, setActiveTab] = useState('subscription');
  const [annualData, setAnnualData] = useState([]);

  useEffect(() => {
    const fetchSubscriptions = async () => {
      try {
        const response = await api.get('/analytics/subscriptions');
        const subscriptions = response.data.subscriptions;

        const processedData = processSubscriptions(subscriptions);
        setAnnualData(processedData);
      } catch (error) {
        console.error('Error fetching subscriptions:', error);
      }
    };

    fetchSubscriptions();
  }, []);

  const processSubscriptions = (subscriptions) => {
    const monthlyCounts = {
      Jan: 0,
      Feb: 0,
      Mar: 0,
      Apr: 0,
      May: 0,
      Jun: 0,
      Jul: 0,
      Aug: 0,
      Sep: 0,
      Oct: 0,
      Nov: 0,
      Dec: 0,
    };

    subscriptions.forEach((sub) => {
      const monthIndex = new Date(sub.startDate).getMonth(); // 0-11
      const monthNames = Object.keys(monthlyCounts);
      const monthName = monthNames[monthIndex];

      if (monthName) {
        monthlyCounts[monthName]++;
      }
    });

    return Object.entries(monthlyCounts).map(([month, value]) => ({
      month,
      value,
      total: Math.max(...Object.values(monthlyCounts)),
    }));
  };

  const currentMonths = [
    { month: 'Jan', value: '9' },
    { month: 'Feb', value: '2' },
    { month: 'Apr', value: '4' },
    { month: 'May', value: '5' },
    { month: 'Jun', value: '6' },
    { month: 'Jul', value: '8' },
  ];

  const subscriptionAlerts = [
    {
      day: '2',
      title: 'Subscription renewal alert',
      time: '10:00-11:30',
      description: '3 of 4 payments, Recharge',
    },
    {
      day: '8',
      title: 'Payment Due',
      time: '11:00-12:30',
      description: '3 of 4 payments, Electricity',
    },
    {
      day: '11',
      title: 'Subscription upgrade',
      time: '10:00-11:30',
      description: '1 of 2 upgrades, Phone',
    },
    {
      day: '23',
      title: 'Bill payment alert',
      time: '10:00-11:30',
      description: '2 of 4 payments, Tuition fees',
    },
    {
      day: '27',
      title: 'Subscription Due',
      time: '10:00-11:30',
      description: '1 of 4 payments, Water Bill',
    },
  ];

  return (
    <div className="p-4 sm:ml-64 w-[80%] bg-[#F4F5F6] font-nohemi">
      <Title title="General Settings" />
      <div className="p-6 bg-white rounded-lg">
        <div className="mb-8 border-b">
          <div className="flex space-x-8 text-sm font-semibold">
            <button
              className={`pb-2 ${
                activeTab === 'subscription'
                  ? 'border-b-2 border-green-500'
                  : 'text-gray-500'
              }`}
              onClick={() => setActiveTab('subscription')}
            >
              Subscription Management
            </button>
            <button
              className={`pb-2 ${
                activeTab === 'advertisement'
                  ? 'border-b-2 border-green-500'
                  : 'text-gray-500'
              }`}
              onClick={() => setActiveTab('advertisement')}
            >
              Advertisement
            </button>
            <button
              className={`pb-2 ${
                activeTab === 'businessType'
                  ? 'border-b-2 border-green-500'
                  : 'text-gray-500'
              }`}
              onClick={() => setActiveTab('businessType')}
            >
              Business Type
            </button>
            <button
              className={`pb-2 ${
                activeTab === 'upload'
                  ? 'border-b-2 border-green-500'
                  : 'text-gray-500'
              }`}
              onClick={() => setActiveTab('upload')}
            >
              Image Upload
            </button>
            <button
              className={`pb-2 ${
                activeTab === 'testimonial'
                  ? 'border-b-2 border-green-500'
                  : 'text-gray-500'
              }`}
              onClick={() => setActiveTab('testimonial')}
            >
              Testimonial Review
            </button>
          </div>
        </div>
        {activeTab === 'subscription' ? (
          <Subscription
            annualData={annualData}
            currentMonths={currentMonths}
            subscriptionAlerts={subscriptionAlerts}
          />
        ) : activeTab === 'businessType' ? (
          <BusinessTypeSettings />
        ) : activeTab === 'advertisement' ? (
          <AdPlacementForm />
        ) : activeTab === 'upload' ? (
          <ImageUploadPage />
        ) : (
          <TestimonialReviewPage />
        )}
      </div>
    </div>
  );
};
export default Settings;
